import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ContactWidget from './components/ContactWidget';
import SEOHead from './components/SEOHead';

// Import all page components
import HomePage from './pages/Home';
import AboutPage from './pages/About';
import ServicesPage from './pages/Services';
import PublicSectorPage from './pages/PublicSector';
import CertificationsPage from './pages/Certifications';
import TestimonialsPage from './pages/Testimonials';
import CareersPage from './pages/Careers';
import ContactPage from './pages/Contact';
import FAQPage from './pages/FAQ';
import IndustriesPage from './pages/Industries';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import TermsOfServicePage from './pages/TermsOfService';
import AccessibilityStatementPage from './pages/AccessibilityStatement';
import EqualOpportunityPage from './pages/EqualOpportunity';
import GovernmentContractingPage from './pages/GovernmentContracting';
import PortalPage from './pages/Portal';
import FacilityMaintenancePage from './pages/FacilityMaintenance';
import RequestQuotePage from './pages/RequestQuote';
import ProjectsPage from './pages/Projects';

// Private Sector Service Pages
import CivilCommercialConstruction from './pages/PrivateSector/CivilCommercialConstruction';
import ProjectManagement from './pages/PrivateSector/ProjectManagement';
import DemolitionSitePreparation from './pages/PrivateSector/DemolitionSitePreparation';
import PlumbingElectricalSystems from './pages/PrivateSector/PlumbingElectricalSystems';
import InteriorFinishes from './pages/PrivateSector/InteriorFinishes';
import StructuralExterior from './pages/PrivateSector/StructuralExterior';
import NationwideRollouts from './pages/PrivateSector/NationwideRollouts';
import TenantBuildouts from './pages/PrivateSector/TenantBuildouts';
import ExtInteriorRemodels from './pages/PrivateSector/ExtInteriorRemodels';
import HealthcareFacilities from './pages/PrivateSector/HealthcareFacilities';
import ExteriorServices from './pages/PrivateSector/ExteriorServices';
import StoreDecommissioning from './pages/PrivateSector/StoreDecommissioning';

// Industry Pages
import GovernmentDefense from './pages/Industries/GovernmentDefense';
import Healthcare from './pages/Industries/Healthcare';
import CommercialRealEstate from './pages/Industries/CommercialRealEstate';
import RetailHospitality from './pages/Industries/RetailHospitality';
import Infrastructure from './pages/Industries/Infrastructure';
import IndustrialManufacturing from './pages/Industries/IndustrialManufacturing';
import Education from './pages/Industries/Education';
import Energy from './pages/Industries/Energy';
import FinancialInstitutions from './pages/Industries/FinancialInstitutions';
import ConvenienceStores from './pages/Industries/ConvenienceStores';
import MultiFamily from './pages/Industries/MultiFamily';
import Retail from './pages/Industries/Retail';
import RestaurantHospitality from './pages/Industries/RestaurantHospitality';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <SEOHead />
      <div className="App premium-design" data-testid="williams-diversified-app">
        <Navbar />
        <ContactWidget />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/certifications" element={<CertificationsPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/accessibility-statement" element={<AccessibilityStatementPage />} />
          <Route path="/equal-opportunity-employer" element={<EqualOpportunityPage />} />
          <Route path="/government-contracting" element={<GovernmentContractingPage />} />
          <Route path="/portal" element={<PortalPage />} />
          <Route path="/facility-maintenance" element={<FacilityMaintenancePage />} />
          <Route path="/request-quote" element={<RequestQuotePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          
          {/* Private Sector Service Routes */}
          <Route path="/private-sector/civil-commercial-construction" element={<CivilCommercialConstruction />} />
          <Route path="/private-sector/project-management" element={<ProjectManagement />} />
          <Route path="/private-sector/demolition-site-preparation" element={<DemolitionSitePreparation />} />
          <Route path="/private-sector/plumbing-electrical-systems" element={<PlumbingElectricalSystems />} />
          <Route path="/private-sector/interior-finishes" element={<InteriorFinishes />} />
          <Route path="/private-sector/structural-exterior" element={<StructuralExterior />} />
          <Route path="/private-sector/nationwide-rollouts" element={<NationwideRollouts />} />
          <Route path="/private-sector/tenant-buildouts" element={<TenantBuildouts />} />
          <Route path="/private-sector/exterior-interior-remodels" element={<ExtInteriorRemodels />} />
          <Route path="/private-sector/healthcare-facilities" element={<HealthcareFacilities />} />
          <Route path="/private-sector/exterior-services" element={<ExteriorServices />} />
          <Route path="/private-sector/store-decommissioning" element={<StoreDecommissioning />} />
          
          {/* Industry Routes */}
          <Route path="/industries/government-defense" element={<GovernmentDefense />} />
          <Route path="/industries/healthcare" element={<Healthcare />} />
          <Route path="/industries/commercial-real-estate" element={<CommercialRealEstate />} />
          <Route path="/industries/retail" element={<Retail />} />
          <Route path="/industries/restaurant-hospitality" element={<RestaurantHospitality />} />
          <Route path="/industries/retail-hospitality" element={<RetailHospitality />} />
          <Route path="/industries/infrastructure" element={<Infrastructure />} />
          <Route path="/industries/industrial-manufacturing" element={<IndustrialManufacturing />} />
          <Route path="/industries/education" element={<Education />} />
          <Route path="/industries/energy" element={<Energy />} />
          <Route path="/industries/financial-institutions" element={<FinancialInstitutions />} />
          <Route path="/industries/convenience-stores" element={<ConvenienceStores />} />
          <Route path="/industries/multi-family" element={<MultiFamily />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
